import React, { FC, MouseEvent } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import frHeartSvg from '@src/svgs/fr-heart.svg';
import { BookmarkTypeEnum, useRemoveBookmarkMutation, useSaveBookmarkMutation } from '@src/graphql/generated';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { removeBookmarkFromCache, addBookmarkToCache } from './utils/updateBookmarksCache';
import { Props } from './props';
import './styles.scss';

export const Save: FC<Props> = ({ user }) => {
  const [saveBookmark] = useSaveBookmarkMutation({
    update: (cache, { data }) => {
      if (data) {
        addBookmarkToCache(cache, data.saveBookmark);
      }
    },
  });

  const [removeBookmark] = useRemoveBookmarkMutation({
    update: cache => removeBookmarkFromCache(cache, user.id),
  });

  function onSaveClick(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();

    const variables = {
      entityId: user.id,
      type: BookmarkTypeEnum.USER,
    };

    trackEvent({
      context: MetricContext.TALENT_AGENT_SEND_MESSAGE_MODAL,
      interaction: user.hasBookmarked ? MetricAction.REMOVE_SAVED_VERIFIED_TALENT : MetricAction.SAVE_VERIFIED_TALENT,
      payload: {
        'User Id': user.id,
      },
    });

    if (user.hasBookmarked) {
      removeBookmark({ variables });
    } else {
      saveBookmark({ variables });
    }
  }

  return (
    <div className="talent-feed-item-actions__item" onClick={onSaveClick}>
      <Svg
        className={classnames(
          'talent-feed-item-actions__icon',
          user.hasBookmarked && 'talent-feed-item-actions-active',
        )}
        src={frHeartSvg}
      />
      <span>Save</span>
    </div>
  );
};
